(() => {
  function init() {
    document.querySelectorAll('[data-dcv-discovery]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      let pending;
      const results = root.querySelector('[data-dcv-results]');
      const status = root.querySelector('[data-dcv-status]');
      root.addEventListener('click', async event => {
        const link = event.target.closest('.dcv-tabs a, .dcv-collection-pagination a');
        if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        pending?.abort();
        const controller = new AbortController();
        pending = controller;
        const url = new URL(link.href);
        // Pagination must retain the active collection order.
        const active = root.querySelector('.dcv-tabs [aria-current="true"]');
        if (!link.closest('.dcv-tabs')) url.searchParams.set('sort_by', new URL(active.href).searchParams.get('sort_by'));
        url.searchParams.set('section_id', root.dataset.sectionId);
        results.setAttribute('aria-busy', 'true');
        status.textContent = 'Loading shirts';
        try {
          const response = await fetch(url, { signal: controller.signal });
          if (!response.ok) throw new Error('Unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const next = doc.querySelector('[data-dcv-results]');
          if (!next) throw new Error('Missing products');
          if (link.hasAttribute('data-dcv-activity')) {
            let ranking;
            if (root.dataset.activityEndpoint) {
              try {
                const ranked = await fetch(root.dataset.activityEndpoint, {signal:controller.signal});
                if (!ranked.ok) throw new Error('Ranking unavailable');
                ranking = (await ranked.json()).productIds;
              } catch (error) {
                if (error.name === 'AbortError') throw error;
              }
            }
            const positions = new Map((ranking || []).map((id,index) => [String(id),index]));
            const cards = [...next.querySelectorAll('[data-dcv-product-id]')];
            // Move existing native cards; do not rebuild product links or quick-add controls.
            cards.sort((a,b) => {
              const ai=positions.get(a.dataset.dcvProductId), bi=positions.get(b.dataset.dcvProductId);
              if (ai !== undefined && bi !== undefined) return ai-bi;
              // Newly published items absent from a cached response lead until next refresh.
              if (ai === undefined && bi !== undefined) return -1;
              if (bi === undefined && ai !== undefined) return 1;
              return Number(b.dataset.dcvPublished)-Number(a.dataset.dcvPublished);
            });
            if (cards.length) cards.forEach(card => cards[0].parentElement.append(card));
          }
          results.replaceChildren(...next.childNodes);
          if (link.closest('.dcv-tabs')) {
            root.querySelectorAll('.dcv-tabs a').forEach(item => item.removeAttribute('aria-current'));
            link.setAttribute('aria-current', 'true');
          }
          status.textContent = `${root.querySelector('.dcv-tabs [aria-current="true"]').textContent} loaded`;
        } catch (error) {
          if (error.name !== 'AbortError') location.assign(link.href);
        } finally {
          if (pending === controller) results.removeAttribute('aria-busy');
        }
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
